import {Await, Outlet, ScrollRestoration, useLoaderData} from 'react-router-dom';
import styles from './app.module.scss';
import {Suspense} from 'react';
import {CenteredSpinner} from './components/spinner/centered_spinner';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Header} from './components/header/header.tsx';
import {ReloadPrompt} from './reload_prompt.tsx';

export function App() {
    const appMode: string = '__APP_MODE__';

    const data = useLoaderData() as {appConfig: Promise<unknown>};

    const inDevelopment = appMode === 'development';

    return (
        <Suspense fallback={<CenteredSpinner />}>
            <ToastContainer />
            <Await resolve={data.appConfig}>
                {() => (
                    <>
                        {inDevelopment && <ReloadPrompt />}

                        <Header />

                        <div id={styles.app}>
                            <Outlet />
                        </div>
                    </>
                )}
            </Await>

            {/*See: https://reactrouter.com/6.29.0/components/scroll-restoration*/}
            <ScrollRestoration
                getKey={(location) => {
                    const paths = ['/occasions', '/notifications', '/chat'];
                    return paths.includes(location.pathname)
                        ? // occasions, notifications and chat restore by pathname
                          location.pathname
                        : // everything else by location like the browser
                          location.key;
                }}
            />
        </Suspense>
    );
}
